import { Injectable } from '@angular/core';
import { Domain } from '@services/public';
import { skillUID } from 'jakapa-utilities-lite';
import { ImageChartEntry } from './common';

export interface LeaderReportAPIResponseSelfAwareness {
	skillUID: skillUID;
	difference: number;
}

@Injectable({
	providedIn: 'root',
})
export class LeaderReportSelfAwarenessService {
	constructor() {}

	generateReport(
		data: Array<LeaderReportAPIResponseSelfAwareness>,
		domain: Domain,
	): Array<ImageChartEntry> {
		const report: Array<ImageChartEntry> = [];
		for (const skill of Object.values(domain.skills)) {
			const difference = data.find(
				(data) => data.skillUID === skill.uid,
			)?.difference;
			if (typeof difference !== 'number') {
				report.push({ name: skill.name, image: 'gauge-gray.svg' });
			} else if (difference <= 0.25) {
				report.push({ name: skill.name, image: 'gauge-green.svg' });
			} else if (difference <= 0.5) {
				report.push({ name: skill.name, image: 'gauge-purpul.svg' });
			} else report.push({ name: skill.name, image: 'gauge-org.svg' });
		}
		return report;
	}
}
